(function () {
  'use strict';

  angular
    .module('dashboard.interval')
    .controller('dashboardIntervalCtrl', dashboardIntervalCtrl);

  dashboardIntervalCtrl.$inject = [
    'DashboardInterval',
    '$translate',
    '$rootScope',
    '$scope',
  ];

  function dashboardIntervalCtrl(
    DashboardInterval,
    $translate,
    $rootScope,
    $scope,
  ) {
    var vm = this;

    var textJanuary = $translate.instant('general.month.january');
    var textFebruary = $translate.instant('general.month.february');
    var textMarch = $translate.instant('general.month.march');
    var textApril = $translate.instant('general.month.april');
    var textMay = $translate.instant('general.month.may');
    var textJune = $translate.instant('general.month.june');
    var textJuly = $translate.instant('general.month.july');
    var textAugust = $translate.instant('general.month.august');
    var textSeptember = $translate.instant('general.month.september');
    var textOctober = $translate.instant('general.month.october');
    var textNovember = $translate.instant('general.month.november');
    var textDecember = $translate.instant('general.month.december');

    $rootScope.$on('$translateChangeSuccess', function () {
      textJanuary = $translate.instant('general.month.january');
      textFebruary = $translate.instant('general.month.february');
      textMarch = $translate.instant('general.month.march');
      textApril = $translate.instant('general.month.april');
      textMay = $translate.instant('general.month.may');
      textJune = $translate.instant('general.month.june');
      textJuly = $translate.instant('general.month.july');
      textAugust = $translate.instant('general.month.august');
      textSeptember = $translate.instant('general.month.september');
      textOctober = $translate.instant('general.month.october');
      textNovember = $translate.instant('general.month.november');
      textDecember = $translate.instant('general.month.december');
    });

    vm.firstLetterToUpper = firstLetterToUpper;
    vm.statistic = {};
    vm.currentDate = new Date();
    vm.periodStart = formatDate(getPeriod(new Date(), vm.type, '-'), vm.type);
    vm.periodEnd = formatDate(vm.currentDate, vm.type);
    vm.getStatistic = getStatistic;
    vm.getPeriodDateClientFormat = getPeriodDateClientFormat;
    vm.prevPeriod = prevPeriod;
    vm.nextPeriod = nextPeriod;
    vm.nextDayLock = true;

    start();

    function start() {
      isValidType();
      vm.getStatistic();
    }

    function isValidType() {
      switch (vm.type) {
        case 'day':
          break;
        case 'week':
          break;
        case 'month':
          break;
        case 'year':
          break;
        default:
          throw new Error('Type ' + vm.type + ' is unaccepted');
      }

      return true;
    }

    function firstLetterToUpper(str) {
      return str.substr(0, 1).toUpperCase() + str.substr(1);
    }

    function getPeriodDateClientFormat() {
      var date = '';
      var periodStart = new Date(String(vm.periodStart));
      var periodEnd = new Date(String(vm.periodEnd));

      switch (vm.type) {
        case 'day':
          date = getMonthName(periodEnd.getMonth()) + ' ' + periodEnd.getDate();
          break;
        case 'week':
          date =
            getMonthName(periodStart.getMonth()) +
            ' ' +
            periodStart.getDate() +
            ' - ' +
            getMonthName(periodEnd.getMonth()) +
            ' ' +
            periodEnd.getDate();
          break;
        case 'month':
          date =
            getMonthName(periodStart.getMonth()) +
            ' ' +
            periodStart.getFullYear();
          break;
        case 'year':
          date = String(periodEnd.getFullYear());
          break;
      }

      return date;
    }

    /**
     * Prepare date to format Y-m-d
     * @param date
     * @returns {string}
     */
    function formatDate(date, type) {
      var day = date.getDate();
      var month = date.getMonth() + 1;
      var formatedDate = '';

      if (day < 10) {
        day = '0' + day;
      }

      if (month < 10) {
        month = '0' + month;
      }

      switch (type) {
        case 'day':
          formatedDate = date.getFullYear() + '-' + month + '-' + day;
          break;
        case 'week':
          formatedDate = date.getFullYear() + '-' + month + '-' + day;
          break;
        case 'month':
          formatedDate = date.getFullYear() + '-' + month;
          break;
        case 'year':
          formatedDate = String(date.getFullYear());
          break;
      }

      return formatedDate;
    }

    function getMonthName(monthIndex) {
      var months = {
        0: textJanuary,
        1: textFebruary,
        2: textMarch,
        3: textApril,
        4: textMay,
        5: textJune,
        6: textJuly,
        7: textAugust,
        8: textSeptember,
        9: textOctober,
        10: textNovember,
        11: textDecember,
      };

      return months[monthIndex];
    }

    function getPeriod(date, type, intervalType) {
      var period = 1;

      switch (type) {
        case 'day':
          type = 'Date';
          break;
        case 'week':
          type = 'Date';
          period = 6;
          break;
        case 'month':
          break;
        case 'year':
          type = 'FullYear';
          break;
        default:
          throw new Error('Date type is not valid');
      }

      switch (intervalType) {
        case '+':
          var interval =
            Number(date['get' + firstLetterToUpper(type)]()) + Number(period);
          break;
        case '-':
          var interval =
            Number(date['get' + firstLetterToUpper(type)]()) - Number(period);
          break;
        default:
          throw new Error('IntervalType is unsupported ' + intervalType);
      }

      date['set' + firstLetterToUpper(type)](interval);

      return date;
    }

    function getStatistic() {
      var params = {
        from: vm.periodStart,
        to: vm.periodEnd,
      };

      if (vm.type == 'day' || vm.type == 'year') {
        params = {
          from: vm.periodEnd,
        };
      }

      DashboardInterval[vm.type](params, function (response) {
        vm.statistic = response;
      });
    }

    function prevPeriod() {
      vm.periodStart = formatDate(
        getPeriod(new Date(vm.periodStart), vm.type, '-'),
        vm.type,
      );
      vm.periodEnd = formatDate(
        getPeriod(new Date(vm.periodEnd), vm.type, '-'),
        vm.type,
      );
      vm.nextDayLock = false;

      getStatistic();
    }

    function nextPeriod(type) {
      vm.periodStart = formatDate(
        getPeriod(new Date(vm.periodStart), vm.type, '+'),
        vm.type,
      );
      vm.periodEnd = formatDate(
        getPeriod(new Date(vm.periodEnd), vm.type, '+'),
        vm.type,
      );

      if (
        (type == 'day' || type == 'week') &&
        new Date(vm.periodEnd) >= vm.currentDate
      ) {
        vm.periodStart = formatDate(
          getPeriod(new Date(vm.periodStart), vm.type, '-'),
          vm.type,
        );
        vm.periodEnd = formatDate(
          getPeriod(new Date(vm.periodEnd), vm.type, '-'),
          vm.type,
        );
        vm.nextDayLock = true;

        return;
      } else if (
        (type == 'day' || type == 'week') &&
        new Date(vm.periodEnd).getDate() == vm.currentDate.getDate()
      ) {
        vm.nextDayLock = true;
      } else if (
        type == 'month' &&
        new Date(vm.periodEnd).getMonth() == vm.currentDate.getMonth()
      ) {
        vm.nextDayLock = true;
      } else if (
        type == 'year' &&
        new Date(vm.periodEnd).getFullYear() == vm.currentDate.getFullYear()
      ) {
        vm.nextDayLock = true;
      } else {
        vm.nextDayLock = false;
      }

      getStatistic();
    }
  }
})();
